import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { EstreamProvider } from '@estream/sdk-browser/react';
import App from './App';
import './styles/global.css';

const EDGE_URL = import.meta.env.VITE_EDGE_URL || 'https://edge.estream.dev:4433';
const NETWORK = import.meta.env.VITE_NETWORK || 'alpha-devnet';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <EstreamProvider 
      config={{ 
        url: EDGE_URL,
        network: NETWORK,
        debug: import.meta.env.DEV,
      }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </EstreamProvider>
  </StrictMode>
);
